import { useState } from "react";
import type {
  PresenceDay,
  PresenceRange,
  PresenceSingle,
} from "../../types/presence";
import Modal from "../Modal";
import NoWorkDaysForm from "./NoWorkDaysForm";
import WorkPermitForm from "./WorkPermitForm";
import Typography from "../Typography";
import Divider from "../Divider";

type Props = {
  date: Date;
  data?: PresenceDay;
  close: () => void;
};

const tabs = [
  { label: "Permesso", value: "permesso" },
  { label: "Ferie", value: "ferie" },
  { label: "Festività", value: "festività" },
  { label: "Chiusura ufficio", value: "chiusura ufficio" },
  { label: "Malattia", value: "malattia" },
  { label: "Maternità", value: "maternità" },
  { label: "Permesso 104", value: "104" },
];

export default function AbsenceModal({ date, data, close }: Props) {
  const [contentToDisplay, setContentToDisplay] = useState<PresenceDay["reason"]>(
    data?.reason ?? "permesso",
  );

  return (
    <Modal open onClose={close} size="small">
      <div className="AbsenceModal">
        <div className="AbsenceModal__header">
          <Typography variant="h5" className="bold">
            Aggiungi assenza per il {date.toLocaleDateString()}
          </Typography>
          <Typography variant="body2">
            Seleziona il tipo di assenza che vuoi aggiungere per questa
            giornata.
          </Typography>
          <select
            value={contentToDisplay}
            onChange={(e) =>
              setContentToDisplay(e.target.value as PresenceDay["reason"])
            }
            disabled={!!data}
            className="flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50"
          >
            {tabs.map((tab) => (
              <option key={tab.value} value={tab.value}>
                {tab.label}
              </option>
            ))}
          </select>
          <Divider />
        </div>
        {(contentToDisplay === "ferie" ||
          contentToDisplay === "festività" ||
          contentToDisplay === "chiusura ufficio" ||
          contentToDisplay === "malattia" ||
          contentToDisplay === "maternità") && (
          <NoWorkDaysForm
            contentToDisplay={contentToDisplay}
            date={date}
            data={data as PresenceRange | undefined}
            triggerAnnulla={close}
          />
        )}
        {(contentToDisplay === "permesso" || contentToDisplay === "104") && (
          <WorkPermitForm
            date={date}
            reason={contentToDisplay}
            data={
              data?.reason === contentToDisplay ? (data as PresenceSingle) : undefined
            }
            triggerAnnulla={close}
          />
        )}
      </div>
    </Modal>
  );
}
